import { connect } from 'react-redux'
import { branch, compose, renderNothing } from 'recompose'
import { selectRefiEligible } from '../../../store/selectors/home/loans'

const ifRefiEligible = compose(
  connect(state => ({
    refiEligible: selectRefiEligible(state)
  })),
  branch(({ refiEligible }) => !refiEligible, renderNothing)
)

export default ifRefiEligible
